import { Dispatch, FC, SetStateAction } from 'react';
import useAddProgramModal from './AddProgramModal.hook';
import DialogForm from 'components/DialogForm';
import Box from 'yoda-ui/components/Box';
import TextYoda from 'yoda-ui/components/Form/TextYoda';
import { YodaFormProvider } from 'yoda-ui/yodaForm';
import { YodaFontSize } from 'yoda-ui/yodaTheme';

type AddProgramModalProps = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
};

const AddProgramModal: FC<AddProgramModalProps> = ({ open, setOpen }) => {
  const {
    addProgramConfig,
    cancelButtonConfig,
    providerFields,
    submitButtonConfig,
    t,
  } = useAddProgramModal(setOpen);

  return (
    <YodaFormProvider { ...providerFields }>
      <DialogForm
        dialogTitle={ t('events_add_program_form_title') }
        open={ open }
        setOpen={ setOpen }
        cancelButtonConfig={ cancelButtonConfig }
        submitButtonConfig={ submitButtonConfig }
      >
        <Box fontSize={ YodaFontSize.xLarge }>
          <TextYoda
            { ...addProgramConfig.programName }
          />
        </Box>
      </DialogForm>
    </YodaFormProvider>
  );
};

export default AddProgramModal;
